import React from 'react';
import ProductPriceFormat from '../../../products/product-price/product-price-format';
import { sendGAEventAddToCart } from '../../../../domain/marketing/gtm-provider';
import { YotpoReview } from '../../../../ui/rating/interfaces';
import StarRating from '../../../../ui/rating/star-rating';
import { outbrainAddToCartEvent } from '../../../../domain/marketing/outbrain-provider';
import InfoIcon from '../../../../ui/svg/common/info';
import { IOnlineMasteringPrice } from './interfaces';

interface IOLPCreditCardProps {
    om: IOnlineMasteringPrice;
    omType: string;
    yotpoReviews: YotpoReview[];
}

const OLPCreditCard = ({
    om,
    omType,
    yotpoReviews,
}: IOLPCreditCardProps) => {

    const bgColor = om.isPostPopular ? 'gradient-pricing-card' : 'olm-pricing-bg-color';
    const border = om.isPostPopular ? 'border-orange' : 'border border-gray-50';

    const marketingNameColor = om.marketingName.includes('Credit') &&
                                                        !om.marketingName.includes('15 Credits') ? 'olm-accent-color': 'text-white';
    const addToCartText = om.skuDepartmentID === 28 ? 'Start Now' : 'Add To Cart';

    const url = `/cart?productid=${ om.skuid }`;

    return (
        <div className={ `${ bgColor } ${ border } flex flex-col rounded-xl olm-pricing-border` }>
            {
                om.isPostPopular &&
                <span className='accent-pricing-badge font-bold w-auto text-tiny md:text-lg py-2 md:py-2 px-4 md:px-8 rounded-full absolute-center top-0'>Popular</span>
            }

            <div className='flex flex-col px-2 pt-8 pb-12'>
                <div className={ `mt-2 text-5xl font-montserrat ${ marketingNameColor }` }>
                    {
                        om.marketingName.includes('Credit') &&
                        <span> <span className='font-bold'>{ om.tokensToReceive }</span> { om.tokensToReceive === 1 ? 'Credit' : 'Credits' }</span>
                    }
                    {
                        !om.marketingName.includes('Credit') &&
                        <span className='font-bold'>{ om.marketingName }</span>
                    }
                </div>

                <div className='text-2xl font-montserrat olm-comment-opacity'>
                    {
                        om.tokensToReceive <= 24 && om.tokensToReceive >= 0 &&
                        <span>Master { om.tokensToReceive } { om.tokensToReceive === 1 ? 'track' : 'tracks' }</span>
                    }
                    {
                        om.tokensToReceive > 24 &&
                        <span>{ om.tokensToReceive } masters /year</span>
                    }
                    {
                        om.tokensToReceive === -1 &&
                        <span className='c-orange'><b>UNLIMITED</b> masters /year</span>
                    }
                </div>

                {
                    omType === 'subscribe' &&
                    <div className='text-sm font-montserrat'>

                        {
                            om.tokensToReceive === -1 &&
                            <div className='mt-2 text-xs text-white'>Subject to <a className='text-xs text-white' href='/legal/online-mastering-fair-usage-policy'>fair use</a></div>
                        }
                        {
                            om.tokensToReceive !== -1 &&
                            <div className='mt-2 text-xs text-white'>&nbsp;</div>
                        }
                    </div>
                }

                {
                    yotpoReviews && yotpoReviews.length > 0 &&
                    <div className='w-full mx-auto flex justify-center mt-6 mb-2'>
                        <StarRating
                            rating={ yotpoReviews[0].rating }
                            reviews={ yotpoReviews[0].reviewsTotal }
                            url={ yotpoReviews[0].documentUrlPath }
                            urlHashHide={ true }
                            colorClass={ 'text-white' }
                        />
                    </div>
                }


                {
                    om.marketingName !== 'Pro' && om.marketingName !== 'Standard' &&
                    <div className='mt-2  font-montserrat font-bold'>
                        <span className='text-5xl'><ProductPriceFormat price={ om.perTrackPrice }/></span>
                        <span className='text-xl olm-comment-opacity'>/</span>
                        <span className='text-2xl olm-comment-opacity'>master</span>
                    </div>
                }

                {
                    om.marketingName === 'Standard' &&
                    <div className='mt-2 font-bold font-montserrat'>
                        <span className='text-5xl'><ProductPriceFormat price={ om.perTrackPrice }/></span>
                        <span className='text-xl olm-comment-opacity'> /</span>
                        <span className='text-2xl olm-comment-opacity'>master</span>
                        <span className='ml-2 relative'>
                                <span className='info-tooltip relative' role='button'>
                                    <InfoIcon classes='inline-block mb-1' width={ '22px' } color={ '#ffffff' }/>
                                </span>
                                <div
                                    className='tooltip-absolute pos-top-left w-64 hidden'
                                    role='tooltip'>
                                    <div className='tooltip'>
                                        <div className='tooltip-box font-owners text-left'>
                                            Unused credits roll over yearly and can be used only with an active Waves Online Mastering subscription.
                                        </div>
                                    </div>
                                </div>
                            </span>
                    </div>

                }

                {
                    om.marketingName === 'Pro' &&
                    <div className='mt-2 font-bold font-montserrat'>
                        <span className='text-2xl olm-comment-opacity'>Under&nbsp;</span>
                        <span className='text-5xl'><ProductPriceFormat price={ om.perTrackPrice }/></span>
                        <span className='text-xl olm-comment-opacity'> /</span>
                        <span className='text-2xl olm-comment-opacity'>master</span>
                        <span className='ml-2 relative'>
                                <span className='info-tooltip relative' role='button'>
                                    <InfoIcon classes='inline-block mb-1' width={ '22px' } color={ '#ffffff' }/>
                                </span>
                                <div
                                    className='tooltip-absolute pos-top-left w-64 hidden'
                                    role='tooltip'>
                                    <div className='tooltip'>
                                        <div className='tooltip-box font-owners text-left'>
                                            The exact price per master will depend on how many tracks you master per year. Credits can be used only with an active Waves Online Mastering subscription.
                                        </div>
                                    </div>
                                </div>
                            </span>

                    </div>
                }

                <div className='font-normal'>
                    <span className='text-2xl olm-comment-opacity'>
                        <ProductPriceFormat price={ om.skuPrice }/>
                        { omType === 'subscribe' && ' /year' }
                        { omType !== 'subscribe' && ' total' }
                    </span>
                </div>

                <div className='mt-8 text-xl'>
                    <a
                        href={ url }
                        className={ `w-48 py-3 mx-auto ${ (om.isPostPopular || om.marketingName === 'Standard') ? 'w-btn  text-black bg-white ': 'w-btn-outline-white olm-pricing-element-border' }` }
                        onClick={ () => {
                            outbrainAddToCartEvent();
                            sendGAEventAddToCart(
                                om.skuName,
                                om.skuid.toString(),
                                om.skuPrice,
                                window.location.pathname,
                                'Waves Online Mastering'
                            );

                        } }
                    >{ addToCartText }</a>
                </div>
            </div>
        </div>
    )
};

export default OLPCreditCard;